import { render, staticRenderFns } from "./package-list.vue?vue&type=template&id=e27d5c32&scoped=true"
import script from "./package-list.vue?vue&type=script&lang=ts"
export * from "./package-list.vue?vue&type=script&lang=ts"
import style0 from "./package-list.vue?vue&type=style&index=0&id=e27d5c32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27d5c32",
  null
  
)

export default component.exports